import React from "react";

import "./index.css";

const SwitchSelect = ({data, onClick, value}) => {
  return <div className="unit-selector">
    <div className={`unit-selector-wrap ${value === data[0] && "unit-selector-select"}`} onClick={() => {onClick(data[0])}}>{data[0]}</div>

    <div className={`unit-selector-wrap ${value === data[1] && "unit-selector-select"}`} onClick={() => {onClick(data[1])}}>{data[1]}</div>
  </div>
};

export default SwitchSelect;
